import { render, staticRenderFns } from "./MetadataIndex.vue?vue&type=template&id=20f0d40a&scoped=true&"
import script from "./MetadataIndex.vue?vue&type=script&lang=js&"
export * from "./MetadataIndex.vue?vue&type=script&lang=js&"
import style0 from "./MetadataIndex.vue?vue&type=style&index=0&id=20f0d40a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f0d40a",
  null
  
)

export default component.exports